import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';

import { TitlePage, SubTitle, InterTitle} from '@styles/styles.global';
import { getColors } from '@styles/colorsTheme';

import Button2 from '@components/Shared/Buttons/Button';

import '@styles/AntStyles.css';
import { CloseOutlined } from '@material-ui/icons';


const RecadoMirim: React.FC = () => {
  const logoClube = 'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/logo-modal.png'


  function handleModalClose() {
    window.location.reload();
  }

  return (
    <>
      <Grid container>

        <Grid container item lg={12} sm={12} xs={12} alignItems="center" justify="center" style={{marginTop: 60, marginBottom: 115}}>

          <Grid container item lg={12} sm={12} xs={12}>
            <Grid  container item lg={3} sm={3} xs={12} alignItems="center" justify="center"></Grid>

            <Grid  container item lg={6} sm={6} xs={12} justify="center"  alignItems="center" style={{ backgroundColor:'#f1f1f166',}}>


                  <Grid  container item lg={12} sm={12} xs={12} justify='flex-end' style={{textAlign:'end', marginRight: 5,}}>
                      <button
                        style={{marginTop: 10, borderColor: 'transparent', backgroundColor: 'transparent'  }}
                        onClick={() => {
                          handleModalClose();
                        }}
                      >
                        <CloseOutlined
                          fontSize="medium"
                          htmlColor={getColors()?.cinzaEscuro}
                        />
                      </button>
                    </Grid>

                    <Grid container item lg={12} sm={12} xs={12}
                     alignItems="center" justify="center" style={{paddingTop: 20}}
                    >
                      <img src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Logotipo_horizontal_principalpng.png'} style={{width: 200, height: 86}} />

                  </Grid>

                <Grid container >
                  <Grid container item lg={12} sm={12} xs={12}
                    alignItems="center" justify="center" style={{ paddingTop: 9}}
                  >
                    <InterTitle>Atenção!</InterTitle>
                  </Grid>
                  </Grid>



                    <Grid  container item lg={12} sm={12} xs={12} justify="center">

                    </Grid>

                    <Grid  container item lg={2} sm={2} xs={12} justify="center"></Grid>

                    <Grid  container item lg={8} sm={8} xs={12} justify="center">

                      <p style={{textAlign:'center', color:'#333', fontSize: '17px', marginTop: 10}}>
                      Para realizar o cadastro de doadores menores de idade, acesse a página exclusiva para crianças.
                      </p>
                      <Button2  color="primary" style={{ width: '254px', height: '78px', borderRadius: '25px', marginBottom: '15px', fontSize: '16px', background: 'linear-gradient(80deg, #8E6CCB, #B084E8)', }} onClick={() => { window.location.href = '/clube-pai-eterno';}} > <img src={logoClube} alt="Ícone" width="200"></img></Button2>


                      <p style={{textAlign:'center', color:'#333', fontSize: '14x', marginTop: 20}}>
                        O Santuário Pai Eterno agradece!
                        </p>
                        <p style={{textAlign:'center', color:'#333', fontSize: '14x', marginBottom: 50}}>
                        <a href="https://www.paieterno.com.br/home-afipe/obras-sociais/" target="_blank" rel="noopener noreferrer" style={{fontSize: 14, color: '#333', textDecorationLine: 'underline'}}> www.paieterno.com.br/home-afipe/obras-sociais/</a>
                        </p>

                    </Grid>

                    <Grid  container item lg={2} sm={2} xs={12} justify="center"></Grid>

                  </Grid>

                  <Grid  container item lg={3} sm={3} xs={12} justify="center"></Grid>
                </Grid>
              </Grid>

      </Grid>

    </>

  );
};

export default RecadoMirim;
